import classNames from "classnames";
import React, { useContext } from "react";
import { PageStickyContext } from "../PageStickyProvider";
import styles from "./PageBar.scss";

const FALLBACK_STICKY_TOP = 84; // barPane (64) + gap (20) when no PageHeader

export const PageBar = ({ children, position = "top" }) => {
    const { pageBarStickyTop, pinnedPageBar } = useContext(PageStickyContext);
    const stickyTop = pageBarStickyTop ?? FALLBACK_STICKY_TOP;

    return (
        <div
            className={classNames(styles.base, {
                [styles.pinned]: pinnedPageBar,
                [styles.bottom]: position === "bottom"
            })}
            style={{ "--page-bar-sticky-top": `${stickyTop}px` }}
        >
            <div className={styles.wrapper}>{children}</div>
        </div>
    );
};
